import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import SimpleSearch from '../../search/SimpleSearch';

export default function FormInputSimpleSearch(props) {
  return <FormInputSearch {...props} searchComponent={SimpleSearch} />;
}
